/*
	Reading the answer from an upload endpoint.

	These endpoints answer with JSON from their own handlers, but a request that fails before it
	reaches one - a size limit hit inside multer, a path that matches no route, a gateway in front
	of the server - comes back as an HTML error page. Parsing that as JSON reports "Unexpected token
	'<', "<!DOCTYPE "... is not valid JSON", which names neither the request that failed nor the
	reason, and is the same message wherever it happens.

	So the body is read as text and, when it is not JSON, described along with the address and the
	status - which is all anybody needs to know where to look.
*/
export async function uploadResponseJson(response:Response,uploadUrl:string)
{
	const body = await response.text();

	try {
		/* Error responses carry JSON too - errorType is how the callers tell what went wrong. */
		return JSON.parse(body);
	}
	catch {
		throw new Error(`Upload to ${uploadUrl} failed: the server answered ${response.status} ${response.statusText || 'with no status text'} and sent ${describeBody(body)} rather than JSON.`);
	}
}

function describeBody(body:string)
{
	const start = body.trim().slice(0,120).replace(/\s+/g,' ');

	if (start == '')
		return 'an empty body';

	return start.startsWith('<') ? `an HTML page ("${start}...")` : `"${start}"`;
}
